export default __webpack_public_path__ + "static/media/gold-packages.b3948e1e.png";